"use strict";

import RWDX, { rwdxComponents } from "./rwdx/RWDX";
import cookies from "./cookies";
import blogScripts from "./blogScripts";
import scrollableContent from "./scrollableContent";
import navigableContent from "./navigableContent";
import interactiveMap from "./interactiveMap";
import impactForm from "./impactForm";

rwdxComponents.init();
RWDX.init();

cookies();

if (document.getElementById("blog-page")) {
	blogScripts();
}

const navButton = document.querySelector("button[data-open-nav]");

navButton?.addEventListener("click", () => {
	document.body.setAttribute(
		"data-nav-open",
		(document.body.dataset.navOpen !== "true").toString()
	);
});

scrollableContent();
navigableContent();

document.addEventListener(
	"error",
	(e) => {
		const target = e.target as HTMLElement;

		if (target.tagName !== "IMG") return;
		const image = target as HTMLImageElement;
		const src = image.src;

		if (src.includes("webp")) {
			image.removeAttribute("srcset");
			image.removeAttribute("sizes");
			image.setAttribute("src", src.replace(/webp/g, "jpg"));
			console.log("replacing webp with jpg");
		}

		if (src.includes("jpg")) {
			image.setAttribute("src", src.replace(/jpg/g, "png"));
			console.log("replacing jpg with png");
		}

		if (src.includes("png")) {
			image.setAttribute("src", null);
			console.log("replacing png with null");
		}
	},
	true
);

const map = document.getElementById("interactive-map");

if (map) {
	interactiveMap();
}

if (document.querySelector('[data-impact-form]')) {
	impactForm()
}
